import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@finitless/shared/contexts";
import { parsePublicLinkInBioPath } from "../lib/linkInBio/linkInBioPublicPath";
import {
  publicRouteTitle,
  routeTitle,
  setDocumentTitle,
  statusTitle,
} from "../lib/browserMetadata";

const BrowserMetadata = () => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();
  const { t, i18n } = useTranslation([
    "auth",
    "common",
    "downloadApp",
    "linkInBioPublic",
  ]);

  useEffect(() => {
    // Public Link-in-Bio owns its customer-derived title and noindex metadata.
    if (parsePublicLinkInBioPath(location.pathname)) return;

    if (isLoading) {
      setDocumentTitle(statusTitle("loading"), t);
      return;
    }

    const publicTitle = publicRouteTitle(location.pathname);
    if (publicTitle) {
      setDocumentTitle(publicTitle, t);
      return;
    }

    if (!isAuthenticated) {
      setDocumentTitle({ namespace: "auth", key: "loginButton" }, t);
      return;
    }

    setDocumentTitle(
      routeTitle(location.pathname) ?? statusTitle("not-found"),
      t,
    );
  }, [i18n.resolvedLanguage, isAuthenticated, isLoading, location.pathname, t]);

  return null;
};

export default BrowserMetadata;
